"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const openAddFont_1 = __importDefault(require("./openAddFont"));
exports.default = (editor, config) => {
    const cm = editor.Commands;
    // @ts-expect-error FIXME: This argument is not assignable
    cm === null || cm === void 0 ? void 0 : cm.add(config.command.id, (0, openAddFont_1.default)(editor, config.command));
};
